module.exports = __webpack_public_path__ + "static/media/imgHacker.33b6187d.svg";